<template>
    <error-message-card class="margin-bottom-normal" :message="errorMessage" />
</template>

<script>
    import ErrorMessageCard from './ErrorMessageCard';
    import {STEP_ERROR_MESSAGES} from '../../../../constants/activation-brief-step-errors';

    export default {
        name:       'StepError',
        components: {
            ErrorMessageCard,
        },
        props: {
            step: {
                type:     Object,
                required: true,
            },
        },
        computed: {
            errorMessage() {
                if (STEP_ERROR_MESSAGES[this.step.name] && STEP_ERROR_MESSAGES[this.step.name][this.step.error]) {
                    return STEP_ERROR_MESSAGES[this.step.name][this.step.error];
                } else {
                    return this.step.error.replace(/_/g, ' ');
                }
            },
        },
    };
</script>
